<template>
  <div
    class="scroll-button"
    @click="handleClick"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1_118)">
        <path
          d="M0.304993 13.1873C0.492521 12.9998 0.746829 12.8945 1.01199 12.8945C1.27716 12.8945 1.53147 12.9998 1.71899 13.1873L9.89099 21.3583C10.4536 21.9207 11.2165 22.2367 12.012 22.2367C12.8075 22.2367 13.5704 21.9207 14.133 21.3583L22.305 13.1873C22.4936 13.0052 22.7462 12.9044 23.0084 12.9066C23.2706 12.9089 23.5214 13.0141 23.7068 13.1995C23.8922 13.3849 23.9974 13.6357 23.9997 13.8979C24.0019 14.1601 23.9012 14.4127 23.719 14.6013L15.547 22.7723C14.6094 23.7097 13.3378 24.2362 12.012 24.2362C10.6862 24.2362 9.41463 23.7097 8.47699 22.7723L0.304993 14.6013C0.117522 14.4138 0.012207 14.1595 0.012207 13.8943C0.012207 13.6292 0.117522 13.3748 0.304993 13.1873Z"
          fill="white"
        />
        <path
          d="M0.304993 3.18732C0.492521 2.99985 0.746829 2.89453 1.01199 2.89453C1.27716 2.89453 1.53147 2.99985 1.71899 3.18732L11.305 12.7733C11.4925 12.9608 11.7468 13.0661 12.012 13.0661C12.2772 13.0661 12.5315 12.9608 12.719 12.7733L22.305 3.18732C22.4936 3.00516 22.7462 2.90437 23.0084 2.90664C23.2706 2.90892 23.5214 3.01409 23.7068 3.1995C23.8922 3.38491 23.9974 3.63572 23.9997 3.89792C24.0019 4.16011 23.9012 4.41272 23.719 4.60132L14.133 14.1873C13.5704 14.7497 12.8075 15.0657 12.012 15.0657C11.2165 15.0657 10.4536 14.7497 9.89099 14.1873L0.304993 4.60132C0.117522 4.41379 0.012207 4.15948 0.012207 3.89432C0.012207 3.62915 0.117522 3.37485 0.304993 3.18732Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_118">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.894348)"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hover: false, // Track hover state
    };
  },
  methods: {
    handleClick() {
      this.$emit("click");
    },
  },
};
</script>

<style scoped>
.scroll-button {
  /* position: fixed; */
  /* bottom: 20px; */
  /* right: 20px; */
  cursor: pointer;
  transition: transform 0.3s ease;
}
</style>
